// React Bootstrap components
import { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import PosameznoStroskovnoMesto from "./PosameznoStroskovnoMesto";
import AddStroskovnoMestoForm from "./AddStroskovnoMestoForm";

// Auth
import RoleGuard from "../../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";

// Context
import { useProjectDetailsContext } from "../../../../context/ProjectDetailsContext";

const StroskovnaMestaClanicCardItem = ({ stroskovnoMestoClanice }) => {
  const [isAdding, setIsAdding] = useState(false);
  const { project } = useProjectDetailsContext();

  return (
    <Card className="mb-3 mt-3">
      <div className="d-flex align-items-center justify-content-between px-3 pt-3">
        <h5 className="mb-2">{stroskovnoMestoClanice?.clanica}</h5>
      </div>
      <div className="px-3 pb-3 pt-2">
        <Row className=" pb-1">
          <Col lg={5} className="text-muted fw-bold">
            Stroškovno mesto
          </Col>
          <Col lg={5} className="text-muted fw-bold">
            Stroškovni nosilec
          </Col>
          <Col lg={2} className="d-flex justify-content-lg-end">
            {!isAdding && (
              <RoleGuard
                moduleKey={MODULES.PROJEKTI}
                roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
                vodilnaClanicaProjektaID={project?.clanicaID}
              >
                <button
                  className="btn btn-sm btn-outline-primary border-0"
                  onClick={() => setIsAdding(true)}
                >
                  <span className="d-flex align-items-center gap-1">
                    Dodaj stroškovno mesto
                  </span>
                </button>
              </RoleGuard>
            )}
          </Col>
        </Row>
        <hr className="py-1 m-0 " />
        {isAdding && (
          <AddStroskovnoMestoForm
            clanicaID={stroskovnoMestoClanice?.clanicaID}
            setIsAdding={setIsAdding}
          />
        )}
        {!isAdding && stroskovnoMestoClanice.seznam.length > 0 ? (
          stroskovnoMestoClanice?.seznam.map((item) => (
            <PosameznoStroskovnoMesto
              key={item.id}
              stroskovnoMestoPosamezno={item}
            />
          ))
        ) : (
          <div className="text-muted ">
            Za to članico ni dodanih stroškovnih mest in nosilcev.
          </div>
        )}
      </div>
    </Card>
  );
};

export default StroskovnaMestaClanicCardItem;
